import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AppService, ColorService, NavigationService, NotificationService, SEOService } from '../../services';
import { Event, FaqSection } from '../../models';
import { EventStore } from '../../stores';
import { filter, Subscription, tap } from 'rxjs';
import { LoaderComponent } from '../../shared/components/loader/loader.component';
import { HelpDirective } from '../../shared/directives/help.directive';
import { LetDirective } from '../../shared/directives/let.directive';
import { EventCoverComponent } from '../../shared/components/event-cover/event-cover.component';
import { EventInfoComponent } from '../../shared/components/event-info/event-info.component';
import { TranslocoModule } from '@ngneat/transloco';
import { EventCustomMessageComponent } from '../../shared/components/event-custom-message/event-custom-message.component';
import { SalePurchaseComponent } from '../../shared/components/sale-purchase/sale-purchase.component';
import { AsyncPipe, DatePipe } from '@angular/common';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss'],
  standalone: true,
  imports: [
    LoaderComponent,
    HelpDirective,
    LetDirective,
    EventCoverComponent,
    EventInfoComponent,
    TranslocoModule,
    EventCustomMessageComponent,
    SalePurchaseComponent,
    AsyncPipe,
    DatePipe,
  ],
})
export class EventComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private eventStore = inject(EventStore);
  private colorService = inject(ColorService);
  private seoService = inject(SEOService);
  private notificationService = inject(NotificationService);
  private navigationService = inject(NavigationService);
  appService = inject(AppService);

  public event: Event;
  public events = new Array<Event>();
  public isLoadingEventInfo = true;
  public faqItems = [FaqSection.Buyer, FaqSection.Seller];
  public now = new Date();

  private eventSub: Subscription;

  constructor() {
    this.seoService.updateTitle('Billets Reelax Tickets');
  }

  ngOnInit() {
    this.getEvent();
  }

  ngOnDestroy() {
    this.colorService.resetEventColor();
    this.eventSub?.unsubscribe();
  }

  getEvent() {
    this.eventSub = this.eventStore.currentEventId$.pipe(
      filter( (eventId) => eventId >= 0),
      tap( () => {
        this.event = this.eventStore.getCurrentEvent();
        if (this.event.color) {
          this.colorService.setEventColor(this.event);
        }

        // SEO
        // Updating Description tag dynamically with title
        this.seoService.updateTitle(this.event.name + ' - Achat et revente de billets');
        this.seoService.updateUrl(environment.domain + 'e/n/' + this.event.url);
        // eslint-disable-next-line max-len
        this.seoService.updateDescription(this.event.organizerName + ' a conclu un partenariat avec Reelax Tickets pour vous permettre d’acheter et de vendre vos billets en toute sécurité !');
        this.seoService.updateImage(this.event.imgUrl, 'Reelax Tickets X ' + this.event.name, this.event.color);

        if (!this.appService.settings.value?.isWidget) {
          this.notificationService.activity(this.event.totalTicketSold, this.event.id);
        }
        this.isLoadingEventInfo = false;
      }),
    ).subscribe({
      next: () => {},
      error: (err) => {
        this.redirectToNotFound();
        // eslint-disable-next-line no-console
        console.log('Error on getEvent function on event component : ', err);
        this.isLoadingEventInfo = false;
      },
    });
  }

  redirectToNotFound() {
    this.router.navigate(['page-introuvable']);
  }

}
